export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-35--g2.95331a23.png";